import Vue from "vue";

export const globalStore = Vue.observable({
    idFormacaoAtual: null,
    formacaoIdCriado: null,
    planoDeTrabalhoId: null,
    dadosPlanoDeTrabalho: null,
    dadosProgramacao: null,
    dadosOrcamento: null,
    isViewMode: false,
    isReenviarSolicitacao: false,
    situacaoId: null,

    setSituacaoId(id) {
        this.situacaoId = id;
    },

    setFormacaoId(id) {
        this.idFormacaoAtual = id;
    },
    
    setReenviarSolicitacao(reenviar) {
        this.isReenviarSolicitacao= reenviar;
    },

    setFormacaoIdCriado(formacaoId) {
        this.formacaoIdCriado = formacaoId;
    },

    setDadosPlanoDeTrabalho(dados) {
        this.dadosPlanoDeTrabalho = dados;
    },

    setDadosOrcamento(dados) {
        this.dadosOrcamento = dados;
    },

    setDadosProgramacao(dados) {
        this.dadosProgramacao = dados;
    },

    setPlanoDeTrabalhoId(planoDeTrabalhoId) {
        this.planoDeTrabalhoId = planoDeTrabalhoId;
    },

    setViewMode(isViewMode) {
        this.isViewMode = isViewMode;
    },

    limpar() {
        this.idFormacaoAtual = null;
        this.formacaoIdCriado = null;
        this.planoDeTrabalhoId = null;
        this.dadosPlanoDeTrabalho = null;
        this.dadosProgramacao = null;
        this.dadosOrcamento = null;
        this.isViewMode = false;
        this.isReenviarSolicitacao = false;
        this.situacaoId = null;
    },
});